import { SubText } from "@base-ui";
import MeasurementsTableHeader from "./MeasurementsTableHeader";
import MeasurementsTableRows from "./MeasurementsTableRows";
import { TableContainer, TableCaption, StyledTable } from "./measurementstable.styles";
import { collectPeriodsBetween, getPeriod } from "utils/periods";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function MeasurementsTable(props) {
  var query = props.query,
    measure = props.measure,
    measurementsWithMetadata = props.measurementsWithMetadata,
    activeFilters = props.activeFilters,
    availableFilters = props.availableFilters,
    organizations = props.organizations,
    measureIds = props.measureIds;
  var dates = collectPeriodsBetween(query.periodType, getPeriod(query.periodType, query.dateFrom), getPeriod(query.periodType, query.dateTo));
  var periodSpan = activeFilters.length * measureIds.length;
  var totalNrOfColumns = dates.length * availableFilters.length;
  var multipleGenders = measureIds.length === 2;
  var periodColGroup = /*#__PURE__*/_jsx("colgroup", {
    id: "periodspan",
    span: periodSpan,
    children: /*#__PURE__*/_jsx("col", {})
  });
  var genderColgroup = multipleGenders && /*#__PURE__*/_jsx("colgroup", {
    id: "genderSpan",
    span: activeFilters.length,
    children: /*#__PURE__*/_jsx("col", {})
  });
  var amountOfHeaderRows = measureIds.length === 2 ? 3 : 2;
  return activeFilters.length > 0 ? /*#__PURE__*/_jsx(TableContainer, {
    children: /*#__PURE__*/_jsxs(StyledTable, {
      "aria-rowcount": query.units.length + amountOfHeaderRows,
      "aria-colcount": totalNrOfColumns,
      children: [/*#__PURE__*/_jsx(TableCaption, {
        children: "Rapporterade v\xE4rden i det valda tidsspannet:"
      }), periodColGroup, genderColgroup, /*#__PURE__*/_jsx(MeasurementsTableHeader, {
        query: query,
        dates: dates,
        multipleGenders: multipleGenders,
        measureIds: measureIds,
        measure: measure,
        activeFilters: activeFilters,
        availableFilters: availableFilters,
        periodSpan: periodSpan
      }), /*#__PURE__*/_jsx("tbody", {
        children: /*#__PURE__*/_jsx(MeasurementsTableRows, {
          query: query,
          dates: dates,
          measure: measure,
          measurementsWithMetadata: measurementsWithMetadata,
          organizations: organizations,
          measureIds: measureIds,
          multipleGenders: multipleGenders,
          amountOfHeaderRows: amountOfHeaderRows,
          activeFilters: activeFilters,
          availableFilters: availableFilters
        })
      })]
    })
  }) : /*#__PURE__*/_jsx(SubText, {
    children: "Du beh\xF6ver aktivera ett av filtrena f\xF6r att se tabellen."
  });
}